import * as types from "./actionTypes";
import * as authApi from "../api/authApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function authenticationSuccess(account) {
  return { type: types.AUTHENTICATION_SUCCESS, account };
}

export function authenticationFailed(account) {
  return { type: types.AUTHENTICATION_FAILED, account };
}

export function loginSuccess(account) {
  return { type: types.LOGIN_SUCCESS, account };
}

export function loginFailed(account) {
  return { type: types.LOGIN_FAILED, account };
}

export function passwordResetSuccess(account) {
  return { type: types.PASSWORD_RESET_SUCCESS, account };
}

export function passwordResetFailed(account) {
  return { type: types.PASSWORD_RESET_FAILED, account };
}

export function adminSuccess(account) {
  return { type: types.ADMIN_SUCCESS, account };
}

export function adminFailed(account) {
  return { type: types.ADMIN_FAILED, account };
}

export function updateAccountVariable(account) {
  return { type: types.UPDATE_ACCOUNT_VARIABLE, account };
}

export function updateSecondaryAccount(account) {
  return { type: types.UPDATE_SECONDARY_ACCOUNT, account };
}

export function deleteSecondary() {
  return { type: types.DELETE_SECONDARY_ACCOUNT };
}

export function mfaRequired(account) {
  return { type: types.MFA_REQUIRED, account };
}

export function mfaSuccess(account) {
  return { type: types.MFA_SUCCESS, account };
}

export function mfaFailed(account) {
  return { type: types.MFA_FAILED, account };
}
export function logout() {
  return { type: types.LOGOUT };
}

export function adminMfaRequired(account) {
  return { type: types.ADMIN_MFA_REQUIRED, account };
}

//Thunks
export function resetPassword(resetDetails) {
  return function (dispatch, getState) {
    dispatch(beginApiCall());
    return authApi
      .resetPassword(resetDetails)
      .then((account) => {
        if (account.status === "Pass") {
          dispatch(passwordResetSuccess(account));
        } else {
          dispatch(passwordResetFailed(account));
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function register(userDetails) {
  return function (dispatch, getState) {
    dispatch(beginApiCall());
    return authApi
      .registerUser(userDetails)
      .then((account) => {
        //console.log(getState());
        if (account.status === "Pass") {
          dispatch(authenticationSuccess(account));
        } else {
          dispatch(authenticationFailed(account));
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function verifyMfa(mfaDetails) {
  return function (dispatch, getState) {
    dispatch(beginApiCall());
    return authApi
      .verifyMfaCode(mfaDetails)
      .then((account) => {
        if (account.status === "Pass") {
          dispatch(mfaSuccess(account));
          dispatch(loginSuccess(account));
        } else {
          dispatch(mfaFailed(account));
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function login(userDetails) {
  return function (dispatch, getState) {
    dispatch(beginApiCall());
    return authApi
      .loginUser(userDetails)
      .then((account) => {
        if (account.status === "Pass") {
          dispatch(loginSuccess(account));
        } else if (account.status === "MFA_REQUIRED") {
          dispatch(mfaRequired(account));
        } else {
          dispatch(loginFailed(account));
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function superlogin(userDetails) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return authApi
      .loginAdmin(userDetails)
      .then((account) => {
        if (account.status === "Pass") {
          dispatch(loginSuccess(account));
        } else if (account.status === "MFA_REQUIRED") {
          dispatch(adminMfaRequired(account));
        } else {
          dispatch(adminSuccess(account));
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function verifyAdminMfa(mfaDetails) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return authApi
      .verifyAdminMfaCode(mfaDetails)
      .then((account) => {
        if (account.status === "MFA_VERIFIED") {
          dispatch(adminSuccess(account));
        } else {
          dispatch(adminFailed(account));
        }
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}
